/**
 * @typedef {{ portrait_cover_url: string | null, cover_url: string, series_cover_url: string | null }} ScenarioCover
 */

/** @param {Pick<ScenarioCover, 'portrait_cover_url' | 'cover_url'>} scenario */
export function scenarioCoverUrl(scenario) {
  return scenario.portrait_cover_url === null ? scenario.cover_url : scenario.portrait_cover_url
}

/** @param {ScenarioCover[]} ordered_scenarios */
export function storyCoverUrl(ordered_scenarios) {
  const portrait = ordered_scenarios.find(scenario => scenario.portrait_cover_url !== null)
  if (portrait !== undefined) return portrait.portrait_cover_url
  return storyLandscapeCoverUrl(ordered_scenarios)
}

/** @param {ScenarioCover[]} ordered_scenarios */
export function storyLandscapeCoverUrl(ordered_scenarios) {
  const series = ordered_scenarios.find(scenario => scenario.series_cover_url !== null && scenario.series_cover_url !== '')
  if (series !== undefined) return series.series_cover_url
  const landscape = ordered_scenarios.find(scenario => scenario.cover_url !== '')
  return landscape === undefined ? '' : landscape.cover_url
}
